import { AppBar, Tabs, Tab, CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import TabPanel, { a11yProps } from "./TabPanel";
import { useSelector, useDispatch } from "react-redux";
import allActions from "../../../../redux/actions";
import { getCoursesByStatus } from "../../MyScheduleComponentBlock/MySchedulePageUtils";
import LevelDetails from "./LevelDetails";
import { getRandomNumber } from "../../../shared/utils/sharedUtils";
import NoDataFound from "../../../shared/NoDataFoundComponent/NoDataFound";
import { CourseData, Level, License, TMSGetCourse } from "../ProgressDetailsInterfaces";
import { dispatchActiveCourseDetails, dispatchUserProgressDetails, getProgressProductId } from "./utils";
import { getCourseListApiCall } from "../../../../redux/actions/progressDetailsAction";
import { skillsProducts } from "../../../../globalConstants";
const LevelTabs = () => {
  const dispatch = useDispatch();
  const allInfo = useSelector((state: any) => state);
  const [subValue, setSubValue] = useState(0);
  const [levelList, setLevelList] = useState<Level[]>([]);
  const [courseData, setCourseData] = useState<CourseData>({
    UserId: '',
    CourseId: '',
    LicenseId: '',
    Level: '',
    productId: ''
  });
  const [subLoaderFlag, setSubLoaderFlag] = useState(false);
  const [learnerDetail, setLearnerDetail] = useState(false);

  useEffect(() => {
    if (!allInfo.tmsCourses.isLoading && !allInfo.tmsCourses.isFailed && !allInfo.tmsCourses.data) {
      const uuId = allInfo.common.luuId;
      dispatch(allActions.tmsCoursesAction.getTMSCourses(uuId));
    }
  }, [allInfo.peopleInformation]);

  useEffect(() => {
    getLearnerDetails();
  }, [allInfo.common.leuId, allInfo.common.productID, allInfo.getLearnerDetails.data]);

  useEffect(() => {
    loadCurrentCourseDetails();
  }, [allInfo.peopleInformation, allInfo.currentCourseDetails, allInfo.tmsCourses.data, allInfo.getLearnerDetails]);

  useEffect(() => {
    getProgressDetails();
  }, [subValue, levelList, allInfo.currentCourseDetails]);


  useEffect(() => {
    getLevelList();
  }, [
    allInfo.peopleInformation,
    allInfo.tmsCourses.data,
    allInfo.currentCourseDetails,
    allInfo.getLearnerDetails.data?.getLearnerInfo
  ]);
  useEffect(() => {
    if(allInfo.getLearnerDetails.isFailed){
      setSubLoaderFlag(false);
    }
  }, [ allInfo.getLearnerDetails.isFailed]);
  const getLearnerDetails = () => {
    if (allInfo.common.productID && allInfo.common.leuId) {
      if (!allInfo.getLearnerDetails.isLoading && !allInfo.getLearnerDetails.data?.getLearnerInfo && !learnerDetail) {
        dispatch(
          allActions.getLearnerDetailsAction.getLearnerDetails(allInfo.common.leuId, Number(getProgressProductId(allInfo.peopleInformation.data.getpeopleInformation.license, skillsProducts)))
        );
        setLearnerDetail(true);
      }
    }
  };
  const handleChangeSubTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    setSubValue(newValue);
  };

  const getLevelList = async () => {
    try {
      if (
        allInfo.currentCourseDetails &&
        !allInfo.currentCourseDetails.isLoading &&
        !allInfo.currentCourseDetails.isFailed &&
        allInfo.currentCourseDetails.data &&
        allInfo.tmsCourses.data &&
        allInfo.getLearnerDetails.data?.getLearnerInfo
      ) {
        setSubLoaderFlag(true);
        const { data: courseDetailsData } = allInfo.currentCourseDetails;
        const { data: tmsCoursesData } = allInfo.tmsCourses;
        const uuId = allInfo.common?.luuId;
        const userID = courseDetailsData?.UserId;
        const courseId = Number(tmsCoursesData?.getTMSGetCourse[0]?.courseId);
        const productId = Number(getProgressProductId(allInfo.peopleInformation.data.getpeopleInformation.license, skillsProducts));
        const licenseId = courseDetailsData?.LicenseId;
        const response = await getCourseListApiCall(uuId, userID, courseId, productId, licenseId);
        if (response) setLevelList(response);
        const index = response.findIndex((item: any) => item.currentModule);
        setSubValue(index);
        setSubLoaderFlag(false);
      }
    } catch (err) {
      console.log(err);
      setSubLoaderFlag(false);
    }
  };

  const loadCurrentCourseDetails = () => {
    try {
      setProduct();
      const hasData =
        allInfo.peopleInformation.data &&
        allInfo.tmsCourses.data &&
        !allInfo.peopleInformation.isLoading &&
        !allInfo.tmsCourses.isLoading &&
        allInfo.getLearnerDetails.data?.getLearnerInfo;
      if (hasData) {
        const filteredSprintLevelLic = filterSprintLevelLicenses(
          allInfo.peopleInformation.data.getpeopleInformation.license
        );
        const shouldDispatchAction = shouldDispatchCourseDetailsAction(allInfo.currentCourseDetails);
        dispatchActiveCourseDetails(shouldDispatchAction, allInfo, getCoursesByStatus, filteredSprintLevelLic, dispatch);
      }
    } catch (err) {
    }
  }

  const getProgressDetails = () => {
    const { data: courseDetailsData } = allInfo.currentCourseDetails;
    const { data: peopleData } = allInfo.peopleInformation;
    if (courseDetailsData && peopleData && levelList.length) {
      dispatchUserProgressDetails(allInfo, courseDetailsData, subValue, dispatch, levelList, setCourseData);
    }
  };

  const setProduct = () => {
    if (
      !allInfo.peopleInformation.isLoading &&
      allInfo.peopleInformation.data &&
      !sessionStorage.getItem("isDemoUser")
    ) {
      const licenses = filterSprintLevelLicenses(allInfo.peopleInformation.data.getpeopleInformation.license);
      if (licenses.length > 0) {
        dispatch(allActions.commonActions.setProductID(licenses[0].productId));
      }
    }
  };

  const filterSprintLevelLicenses = (licenses: License[]) => {
    return licenses.filter((prod: { productId: string }) =>
      ["20", "18", "21", "22", "23", "24", "25", "29"].includes(prod.productId)
    );
  };

  const shouldDispatchCourseDetailsAction = (currentCourseDetails: {
    isLoading: boolean;
    isFailed: boolean;
    data: TMSGetCourse[];
  }) => {
    return !currentCourseDetails.isLoading && !currentCourseDetails.isFailed && !currentCourseDetails.data;
  };

  return (
    <>
      {Array.isArray(levelList) && levelList.length ? (
        <>
          <AppBar position="static" color="default">
            {Array.isArray(levelList) && (
              <Tabs
                value={subValue}
                onChange={handleChangeSubTab}
                className={"tabs-trigger-container h2-tab"}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                aria-label="sprint levels level tabs"
              >
                {levelList?.map((element: Level, mainIndex: number) => (
                  <Tab key={getRandomNumber(mainIndex)} label={element?.title} {...a11yProps(mainIndex)} />
                ))}
              </Tabs>
            )}
          </AppBar>
          {Array.isArray(levelList) && levelList[subValue] && (
            <TabPanel value={subValue} index={subValue}>
              {allInfo.progressDetails.isLoading ? (
                <div className="circular-progress-container">
                  <div className="circular-progress-img">
                    <CircularProgress size={50} color="primary" />
                  </div>
                </div>
              ) : (
                ""
              )}
              {allInfo.progressDetails.data ? (
                <LevelDetails
                  data={allInfo.progressDetails.data}
                  activeLevel={levelList[subValue]}
                  courseData={courseData}
                />
              ) : (
                ""
              )}
            </TabPanel>
          )}
        </>
      ) : (
        <>
          {subLoaderFlag ? (
            <CircularProgress
              size={50} 
              color="primary"
              />
          ) : (
            <NoDataFound notProgressPage={!!allInfo.getLearnerDetails?.data?.getLearnerInfo} />
          )}
        </>
      )}
    </>
  );
};

export default LevelTabs;
